import { ALL_PAGES } from '../constants/app';
import { FLEET_ALL_PAGES } from '../constants/fleet';

const PAGES_UNIVERSE = [...ALL_PAGES, ...FLEET_ALL_PAGES];

export const getPageTitle = (pageId: string) => {
  const page = PAGES_UNIVERSE.find((page) => page.id === pageId);
  return page?.pageTitle || page?.name;
};

export const getPageNavKey = (pageId: string) => {
  return PAGES_UNIVERSE.find((page) => page.id === pageId)?.navKey;
};

export const getPageRouteByNavKey = (workspaceId: string, navKey?: string) => {
  return PAGES_UNIVERSE.find((page) => page.navKey === navKey)?.route.replace(':id', workspaceId);
};

export const getPageRoute = (id?: string) => {
  return PAGES_UNIVERSE.find((page) => page.id === id)?.route;
};
